<div class="stars">
    <div class="positive" :style="'width:' + percent + '%;'"></div>
</div>
